import Cookies from 'components/cookies/cookies';
import ArrowRightIcon from 'components/Icons/ArrowRightIcon';
import { RefreshIcon } from 'components/Icons/RefreshIcon';
import LayoutContext from 'components/Layout/LayoutContext';
import ConsultaEventosModal from 'components/Modal/__LEGACY__/ConsultaEventosModal/ConsultaEventosModal';
import BannerAssembleia from 'components/__SHARED__/BannerAssembleia/BannerAssembleia';
import BannerPesquisaCpfCnpj from 'components/__SHARED__/BannerPesquisaCpfCnpj/BannerPesquisaCpfCnpj';
import InformativoAssembleiasComImagem from 'components/__SHARED__/InformativoAssembleiasComImagem/InformativoAssembleiasComImagem';
import InformativoAssembleiasComVideo, {
  InformativoAssembleiasComVideoAlign,
} from 'components/__SHARED__/InformativoAssembleiasComVideo/InformativoAssembleiasComVideo';
import PublicContainer from 'components/__SHARED__/PublicContainer';
import {
  formatCPFOrCNPJ,
  getUnmaskedValue,
  validaCPF,
} from 'helpers/utils/cpfCnpjMask';
import { clsx, dispatchToAllYouTubeVideos } from 'helpers/utils/HTMLUtils';
import { getUniqueKey } from 'helpers/utils/KeyUtils';
import { validaCNPJ } from 'helpers/utils/ValidationUtils';
import { getApis } from 'library/Apis';
import {
  AssessorRoutePath,
  AssociadoRoutePath,
  cpfAnchorRoutePath,
} from 'library/Routes';
import translation from 'locales/translation';
import {
  Button,
  CarouselPersona,
  Col,
  IconButton,
  ModalSizes,
  PreviaVideo,
  Row,
  ScreenSize,
  ToastTypes,
  useScreenSize,
  VideoModal,
} from 'plataforma-fundacao-componentes';
import {
  Fragment,
  useCallback,
  useContext,
  useEffect,
  useMemo,
  useRef,
  useState,
} from 'react';
import ReCAPTCHA from 'react-google-recaptcha';
import { useDispatch, useSelector } from 'react-redux';
import { useRouteMatch } from 'react-router-dom';
import { scroller } from 'react-scroll';
import { assembleiasAssociadoActionsLoadByCpfCnpj } from 'store/modules/AssembleiasAssociadoActions';
import { closeModal, openModal } from 'store/modules/ModalActions';
import { IReducer } from 'store/Reducer';
import { history } from 'store/Store';
import assembleia from '../../assets/images/homeConsulta/calendar.png';
import conselheiroAdm from '../../assets/images/homeConsulta/conselheiroAdm.png';
import conselheiroFiscal from '../../assets/images/homeConsulta/conselheiroFiscal.png';
import coordenadorNucleo from '../../assets/images/homeConsulta/coordenador.png';
import thumbDistribuicao from '../../assets/images/homeConsulta/DistribuicaoDeResultados.png';
import bannerAssembleiaImg from '../../assets/images/homeConsulta/hero.png';
import imgOqueSao from '../../assets/images/homeConsulta/info1.png';
import imgOqueAcontece from '../../assets/images/homeConsulta/info2.png';
import imgParticipe from '../../assets/images/homeConsulta/info3.png';
import thumbOqueAcontece from '../../assets/images/homeConsulta/OQueAconteceEmUmaAssembleia.png';
import thumbPqSuaParticipacaoImporta from '../../assets/images/homeConsulta/ParticipacaoImportante.png';
import presidenteConselho from '../../assets/images/homeConsulta/presidenteConselho.png';
import {
  default as thumbVideo,
  default as thumbVideoMobile,
} from '../../assets/images/homeConsulta/videoBg.png';
import styles from './Consulta.scss';
const rootClassName = styles.rootClassName;

const Home = () => {
  const [cpfCnpj, setCpfCnpj] = useState('');
  const dispatch = useDispatch();
  const match = useRouteMatch();
  const { rankedSize: screenSize } = useScreenSize();
  const { assembleias } = useSelector((state: IReducer) => state);
  const { loadingConsultaByCpfCnpj } = assembleias;

  const { showToast } = useContext(LayoutContext);

  const openVideoModal = (urlVideo: string) => {
    dispatchToAllYouTubeVideos('stopVideo');
    setTimeout(() => {
      const mk = `modal${getUniqueKey()}`;
      dispatch(
        openModal(VideoModal, {
          modalKey: mk,
          onClose: () => dispatch(closeModal(mk)),
          mobileOnXS: false,
          size: ModalSizes.Small,
          urlVideo,
          videoPlayerProps: {
            formatUrl: true,
            autoPlay: true,
          },
        })
      );
    }, 100);
  };

  const podeConsultar = useMemo(() => {
    return validaCPF(cpfCnpj) || validaCNPJ(cpfCnpj);
  }, [cpfCnpj]);

  const [captchaToken, setCaptchaToken] = useState<any>();
  const recaptchaRef = useRef<any>(null);

  const resetCaptcha = useCallback(() => {
    if (
      recaptchaRef.current &&
      typeof recaptchaRef.current.reset === 'function'
    ) {
      recaptchaRef.current!?.reset();
      setCaptchaToken(undefined);
    }
  }, [recaptchaRef]);

  const consultarEventos = useCallback(() => {
    dispatch(
      assembleiasAssociadoActionsLoadByCpfCnpj(
        getUnmaskedValue(cpfCnpj),
        captchaToken,
        () => {
          const modalKey: string = getUniqueKey();
          setTimeout(() => {
            dispatch(
              openModal(ConsultaEventosModal, {
                modalKey,
                cpfCnpj,
                preventMaskExit: true,
                mobileOn: ScreenSize.xs,
                onClose: () => dispatch(closeModal(modalKey)),
              })
            );
            resetCaptcha();
          }, 150);
        },
        () => {
          showToast({
            pauseOnFocusLoss: true,
            theme: ToastTypes.Error,
            showStatusBar: true,
            timeout: 4000,
            label: translation.Consulta.pesquisaCpfCnpj.erroAoPesquisar,
          });
          resetCaptcha();
        }
      )
    );
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [captchaToken, cpfCnpj, dispatch, resetCaptcha]);

  useEffect(() => {
    if (captchaToken && podeConsultar) {
      consultarEventos();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [captchaToken]);

  useEffect(() => {
    if (match.path === cpfAnchorRoutePath) {
      scroller.scrollTo('pesquisa-cpf-cnpj', {
        containerId: 'public-container',
        duration: 700,
        delay: 150,
        smooth: 'easeInOutQuart',
        offset: -5,
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className={rootClassName}>
      <PublicContainer>
        <Row>
          <Col noPadding>
            <BannerAssembleia
              buttonLabel={translation.LoginAssociado.botao}
              imgUrl={bannerAssembleiaImg}
              onButtonClick={() => {
                history.push(AssociadoRoutePath);
              }}
              text={translation.Consulta.bannerAssembleia.text}
              description={translation.Consulta.bannerAssembleia.description()}
              green
            />
          </Col>
        </Row>
        <Row>
          <Col noPadding>
            <PreviaVideo
              imgUrl={
                screenSize === ScreenSize.sm || screenSize === ScreenSize.xs
                  ? thumbVideoMobile
                  : thumbVideo
              }
              urlVideo={'https://youtu.be/3UYv6SorAT0'}
              label={translation.Consulta.labelVideo}
              videoPlayerProps={{
                autoPlay: true,
                formatUrl: true,
              }}
            />
          </Col>
        </Row>
        <Row className='mt-50 mb-50'>
          <Col className={`${rootClassName}-section-title`}>
            {translation.Consulta.saibaMais.title}
          </Col>
        </Row>
        <Row>
          <Col
            className={`${rootClassName}-info-videos-col`}
            cols={[12, 12, 4, 4, 4]}
          >
            <InformativoAssembleiasComVideo
              imgUrl={thumbOqueAcontece}
              title={translation.Consulta.saibaMais.cards.oqueacontece.title}
              subtitle={
                translation.Consulta.saibaMais.cards.oqueacontece.subtitle
              }
              onClick={() =>
                openVideoModal(
                  'https://www.youtube.com/watch?v=g_1PErWmTf0&list=PLRrDx3q9i--5vngacrjBSSfTyAiEde1gz&index=3?autoplay=1&enablejsapi=true&origin=' +
                    window.origin
                )
              }
              align={InformativoAssembleiasComVideoAlign.Center}
            />
          </Col>
          <Col
            className={`${rootClassName}-info-videos-col`}
            cols={[12, 12, 4, 4, 4]}
          >
            <InformativoAssembleiasComVideo
              imgUrl={thumbPqSuaParticipacaoImporta}
              title={
                translation.Consulta.saibaMais.cards
                  .porqueSuaParticipacaoImporta.title
              }
              subtitle={
                translation.Consulta.saibaMais.cards
                  .porqueSuaParticipacaoImporta.subtitle
              }
              onClick={() =>
                openVideoModal(
                  'https://www.youtube.com/watch?v=md-lX9Tr874&list=PLRrDx3q9i--5vngacrjBSSfTyAiEde1gz&index=2?autoplay=1&enablejsapi=true&origin=' +
                    window.origin
                )
              }
              align={InformativoAssembleiasComVideoAlign.Center}
            />
          </Col>
          <Col
            className={`${rootClassName}-info-videos-col`}
            cols={[12, 12, 4, 4, 4]}
          >
            <InformativoAssembleiasComVideo
              imgUrl={thumbDistribuicao}
              title={translation.Consulta.saibaMais.cards.distribuicao.title}
              subtitle={
                translation.Consulta.saibaMais.cards.distribuicao.subtitle
              }
              onClick={() =>
                openVideoModal(
                  'https://www.youtube.com/watch?v=Vt2wtkmVB74&list=PLRrDx3q9i--5vngacrjBSSfTyAiEde1gz&index=5?autoplay=1&enablejsapi=true&origin=' +
                    window.origin
                )
              }
              align={InformativoAssembleiasComVideoAlign.Center}
            />
          </Col>
        </Row>
        <Row className='mt-50'>
          <Col className={`${rootClassName}-info-fotos`} centralized>
            <InformativoAssembleiasComImagem
              urlImg={imgOqueSao}
              title={translation.Consulta.informativos.oQueSaoAssembleias.title}
              subtitle={
                translation.Consulta.informativos.oQueSaoAssembleias.subtitle
              }
              buttonLabel={translation.Consulta.informativos.buttonLabel}
              onButtonClick={() => {
                history.push(AssociadoRoutePath);
              }}
              reverse
              filledButton
            />
          </Col>
        </Row>
        <Row className='mt-50'>
          <Col className={`${rootClassName}-info-fotos`} centralized>
            <InformativoAssembleiasComImagem
              urlImg={imgOqueAcontece}
              title={
                translation.Consulta.informativos.oQueAconteceNessesEncontros
                  .title
              }
              subtitle={
                translation.Consulta.informativos.oQueAconteceNessesEncontros
                  .subtitle
              }
              buttonLabel={translation.Consulta.informativos.buttonLabel}
              onButtonClick={() => {
                history.push(AssociadoRoutePath);
              }}
              filledButton
            />
          </Col>
        </Row>
        <Row className='mt-50'>
          <Col className={`${rootClassName}-info-fotos`} centralized>
            <InformativoAssembleiasComImagem
              urlImg={imgParticipe}
              title={
                translation.Consulta.informativos.participeDasAssembleias.title
              }
              subtitle={
                translation.Consulta.informativos.participeDasAssembleias
                  .subtitle
              }
              buttonLabel={translation.Consulta.informativos.buttonLabel}
              onButtonClick={() => {
                history.push(AssociadoRoutePath);
              }}
              reverse
              filledButton
              buttonMarginTop
            />
          </Col>
        </Row>
        <Row className={clsx(['mt-50', `${rootClassName}-more-padding`])}>
          <Col className={`${rootClassName}-edital`}>
            <Row>
              <Col
                cols={[12, 12, 6, 4, 4]}
                className={`${rootClassName}-edital-left`}
              >
                <div>
                  <span>Editais</span>
                  <h1>Assembleias</h1>
                  <p>Sicredi 2025</p>
                </div>
              </Col>
              <Col
                cols={[12, 12, 6, 4, 4]}
                className={`${rootClassName}-edital-center`}
                noPadding
              >
                <div>
                  <h1>Fique por dentro das Assembleias</h1>
                  <p>
                    Confira o arquivo com os editais de convocação para as
                    Assembleias 2025 da sua cooperativa.
                  </p>
                </div>
              </Col>
              <Col
                cols={[12, 12, 12, 4, 4]}
                className={`${rootClassName}-edital-right`}
                centralized
              >
                <Button
                  onClick={() =>
                    window.open(
                      'https://www.sicredi.com.br/site/sobre-nos/relatorios/editais-assembleias-2024/ ',
                      '_blank'
                    )
                  }
                >
                  Acesse aqui
                </Button>
              </Col>
            </Row>
          </Col>
        </Row>
        <Row className='mt-50'>
          <Col
            id='pesquisa-cpf-cnpj'
            className={clsx([
              `${rootClassName}-pesquisa-cpf-cnpj`,
              `${rootClassName}-more-padding`,
            ])}
            centralized
          >
            <BannerPesquisaCpfCnpj
              theme='white'
              title={translation.Consulta.pesquisaCpfCnpj.title}
              subtitle={translation.Consulta.pesquisaCpfCnpj.subtitle}
              inputProps={{
                value: cpfCnpj,
                onChange: (evt: any) =>
                  setCpfCnpj(formatCPFOrCNPJ(evt.target.value)),
                onKeyDown: (evt: any) => {
                  if (evt.key === 'Enter' && podeConsultar) {
                    consultarEventos();
                  }
                },
                inputMode: 'numeric',
                placeholder: translation.Consulta.pesquisaCpfCnpj.placeholder,
                rightObject: (
                  <IconButton
                    icon={
                      loadingConsultaByCpfCnpj ? (
                        <RefreshIcon />
                      ) : (
                        <ArrowRightIcon />
                      )
                    }
                    disabled={!podeConsultar || !captchaToken}
                    onClick={() => {
                      consultarEventos();
                    }}
                  />
                ),
              }}
              urlImg={assembleia}
              captcha={
                <Row>
                  <Col noPadding centralized>
                    <ReCAPTCHA
                      ref={recaptchaRef}
                      sitekey={getApis().captchaKey}
                      theme='light'
                      size='normal'
                      onChange={setCaptchaToken}
                      hl='pt-BR'
                    />
                  </Col>
                </Row>
              }
            />
          </Col>
        </Row>
        <button
          style={{ width: '2px', height: '2px' }}
          onClick={() => history.push(AssessorRoutePath)}
          data-testid={'redirect-assessor'}
        ></button>
        <Row className='mt-50 mb-50'>
          <Col
            className={clsx([
              `${rootClassName}-section-title`,
              `${rootClassName}-more-padding`,
            ])}
          >
            {translation.Consulta.personas.title}
          </Col>
        </Row>
        <Row>
          <Col className={`${rootClassName}-more-padding`}>
            <CarouselPersona
              personas={[
                {
                  imgUrl: coordenadorNucleo,
                  name: translation.Consulta.personas.coordenador.name,
                  description:
                    translation.Consulta.personas.coordenador.description,
                },
                {
                  imgUrl: conselheiroAdm,
                  name: translation.Consulta.personas.conselheiroAdm.name,
                  description:
                    translation.Consulta.personas.conselheiroAdm.description,
                },
                {
                  imgUrl: presidenteConselho,
                  name: translation.Consulta.personas.presidenteConselho.name,
                  description:
                    translation.Consulta.personas.presidenteConselho
                      .description,
                },
                {
                  imgUrl: conselheiroFiscal,
                  name: translation.Consulta.personas.conselheiroFiscal.name,
                  description:
                    translation.Consulta.personas.conselheiroFiscal.description,
                },
              ]}
            />
          </Col>
        </Row>
      </PublicContainer>
      {getApis()?.cookies?.active ? <Cookies /> : <Fragment />}
    </div>
  );
};

export default Home;
